import type { SVGProps } from 'react';
const SvgIconDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M6 8.75a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-1.5 0zM9.25 8a.75.75 0 0 0-.75.75v2a.75.75 0 0 0 1.5 0v-2A.75.75 0 0 0 9.25 8"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.5 1a1 1 0 0 0-1 1v.5h-3A1.5 1.5 0 0 0 1 4v1a1.5 1.5 0 0 0 .73 1.287l.453 5.905A2.5 2.5 0 0 0 4.676 14.5h6.648a2.5 2.5 0 0 0 2.493-2.308l.454-5.905A1.5 1.5 0 0 0 15 5V4a1.5 1.5 0 0 0-1.5-1.5h-3V2a1 1 0 0 0-1-1zM3.25 6.5h9.5l-.429 5.577a1 1 0 0 1-.997.923H4.676a1 1 0 0 1-.997-.923zM13.5 4v1h-11V4z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconDelete;
